import React from 'react'
import { ColumnMapping, HaircutType, SpreadsheetSettlementVenue, SpreadsheetMapping } from 'api'

import { Locale, Translation } from 'locale'
import { HaircutTypeHelper, SpreadsheetSettlementVenueHelper } from 'model'
import { IncomingPriceUpload, IncomingSpreadsheetParseResult } from 'view/shared/incomingUpload'
import {
  ColumnMappingDatePanel,
  ColumnMappingEnumPanel,
  ColumnMappingStringPanel,
  ColumnsContainer,
  ColumnsHeader,
  ColumnsHeaderPanel
} from 'view/shared/upload/mappingDialog'
import { NonParsableCurveSettlementVenueTypes } from './parseCurveSpreadsheet'

export interface IncomingDialogColumnsProps {
  mapping: SpreadsheetMapping
  parseResult: IncomingSpreadsheetParseResult<IncomingPriceUpload>
  onUpdate: (mapping: SpreadsheetMapping) => unknown
}

export const CurveMappingDialogColumns: React.FC<IncomingDialogColumnsProps> = props => {
  const { mapping, parseResult, onUpdate } = props

  const handleColumnUpdate = (columnMapping: ColumnMapping, fieldName: keyof SpreadsheetMapping) =>
    onUpdate({ ...mapping, [fieldName]: columnMapping })

  return (
    <ColumnsContainer>
      <ColumnsHeaderPanel>
        <ColumnsHeader>{Locale.translate(Translation.TC_INCOMING_FIELD)}</ColumnsHeader>
        <ColumnsHeader>{Locale.translate(Translation.TC_SPREADSHEET_COLUMN)}</ColumnsHeader>
      </ColumnsHeaderPanel>
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_COLLECTION_ID)}
        fieldName="collectionId"
        columnMapping={mapping.collectionId}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_TERM)}
        fieldName="term"
        columnMapping={mapping.term}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingDatePanel
        fieldTitle={Locale.translate(Translation.TC_START_DATE)}
        fieldName="startDate"
        columnMapping={mapping.startDate}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingDatePanel
        fieldTitle={Locale.translate(Translation.TC_END_DATE)}
        fieldName="endDate"
        columnMapping={mapping.endDate}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />

      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_RATE)}
        fieldName="rate"
        columnMapping={mapping.rate}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingStringPanel
        fieldTitle={Locale.translate(Translation.TC_HAIRCUT)}
        fieldName="haircut"
        columnMapping={mapping.haircut}
        parseResult={parseResult}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingEnumPanel
        fieldTitle={Locale.translate(Translation.TC_HAIRCUT_TYPE)}
        fieldName="haircutType"
        columnMapping={mapping.haircutType}
        parseResult={parseResult}
        Enum={HaircutType}
        enumHelper={HaircutTypeHelper}
        onUpdate={handleColumnUpdate}
      />
      <ColumnMappingEnumPanel
        excludeValues={NonParsableCurveSettlementVenueTypes}
        fieldTitle={Locale.translate(Translation.TC_SETTLEMENT_TYPE)}
        fieldName="settlementVenue"
        columnMapping={mapping.settlementVenue}
        parseResult={parseResult}
        Enum={SpreadsheetSettlementVenue}
        enumHelper={SpreadsheetSettlementVenueHelper}
        onUpdate={handleColumnUpdate}
      />
    </ColumnsContainer>
  )
}
